class ToggleAllService extends BaseService
	@register angular.module 'App.Service'

	initialize: ->
		@skipWithProperty = 'virtual'
		@isAllSelected = true
		@items = []

	toggleAll: ->
		for data in @items
			for datum in data
				datum.selected = @isAllSelected

	setToggleAll: (item, subItems) ->
		@setLocalToggleAll(item, subItems) if not _.isEmpty(subItems)
		@setGlobalToggleAll()

	setGlobalToggleAll: ->
		selectedCount = 0
		total = 0

		for data in @items
			for datum in data
				selectedCount++ if datum.selected
				total++

		@isAllSelected = null
		@isAllSelected = false if selectedCount == 0
		@isAllSelected = true if selectedCount == total

	setLocalToggleAll: (item, subItems) ->
		if @skipWithProperty? and item[@skipWithProperty]
			for subItem in subItems
				subItem.selected = item.selected

			return

		excludedItem = _.find subItems, {"#{@skipWithProperty}": true}

		return if not excludedItem?

		selectedCount = 0
		total = 0

		for subItem in subItems
			if not @skipWithProperty? or not subItem[@skipWithProperty]
				selectedCount++ if subItem.selected
				total++ if not @skipWithProperty? or not subItem[@skipWithProperty]

		excludedItem.selected = null
		excludedItem.selected = false if selectedCount == 0
		excludedItem.selected = true if selectedCount == total
